import React, { useEffect, useRef } from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import InputBase from '@mui/material/InputBase';
import Badge from '@mui/material/Badge';
import MenuItem from '@mui/material/MenuItem';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import NotificationsIcon from '@mui/icons-material/Notifications';
import MoreIcon from '@mui/icons-material/MoreVert';
import SearchIcon from '@mui/icons-material/Search';
import LoginDialog from '../user/login/login-dialog'
import { 
  Avatar, 
  Divider, 
  List, 
  ListItem, 
  ListItemButton, 
  ListItemIcon, 
  ListItemText, 
  SwipeableDrawer 
} from '@mui/material';

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import EditNoteIcon from '@mui/icons-material/EditNote';
import { useAuth } from '../../hooks/useAuth';
import AddIcon from '@mui/icons-material/Add';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import { getInbox } from '../../services/material-services';
import Logout from '@mui/icons-material/Logout';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import BrightnessHighIcon from '@mui/icons-material/BrightnessHigh';
import CalendarViewMonthIcon from '@mui/icons-material/CalendarViewMonth';
import CameraFrontIcon from '@mui/icons-material/CameraFront';
import User from '../user/user';
import { blueGrey } from '@mui/material/colors';


function NavBarHeader({materials, onBack}) {
    const { authData, setAuthGroup, 
      authDataGroup, authDataLang } = useAuth()
      
    const [isAdmin, setIsAdmin] = useState(false)
    // const [matGroup, setMatGroup] = useState('')
    
    const countShow = 100
    // const countInbox = 0
    const defPage = 1
    const searchFact = '&status_read=false&req_status=true'
    const [countInbox, setCountInbox] = useState(0);
    // const [countShow, setCountShow] = useState(100);
    // const [defPage, setDefPage] = useState(1);
    // const [searchFact, setSearchFact] = useState('&status_read=false&req_status=true');
    // const [error, setError] = useState(false)
    // const [loading, setLoding] = useState(false)
    // const [focused, setFocused] = useState(false);
    
    const [anchorProfile, setAnchorProfile] = useState(null)
    const openProfileM = Boolean(anchorProfile)
    
    const [anchorEl, setAnchorEl] = useState(false)
    const [inboxMenu, setInboxMenu] = useState(null)
    const [mobileMoreAnchorEl, setMobileMoreAnchorEl] = useState(null)
    const [searchData, setSearchData] = useState('')
    const isMenuOpen = Boolean(inboxMenu)
    const isMobileMenuOpen = Boolean(mobileMoreAnchorEl)
        
    const [flagRun, setFlagRun] = useState(0)
    const [openLogin, setOpenLogin] = useState(false)
    const [newLoginPage, setNewLoginPage] = useState(false)

    
    const handlerLoginBack = (value) => {

        if(value?.close)
        {
            setOpenLogin(false)
        }
        // if (authData && authData?.token){
        //     router.push(`/user/myaccount/?menu=account`)
        // }
    }
    const navigate = useNavigate()

    const [expanded, setExpanded] = useState(false);
    const inputRef = useRef(null);

  
    const handleSearchClick = () => {
      setExpanded(true);
      // بعد از باز شدن، روی فیلد ورودی فوکوس می‌کنیم
      setTimeout(() => {
        inputRef.current?.focus();
      }, 100);
    };
  
    const handleBlur = () => {
      setExpanded(false);
      // console.log(searchData);
      
      onBack(searchData); // اجرای تابع بیرونی وقتی کادر از فوکوس خارج شد
    };
    const handleKeyDown = (e) => {
      if (e.key === 'Enter') {
        onBack(searchData); // وقتی Enter زده شد
      }
    };

    useEffect(() => {
      if(authData?.user){
          setIsAdmin(authData.user.profile?.is_permium)
      }
      // console.log('user', authData);
      
      // if(authDataGroup)
      // {
      //     setMatGroup(authDataGroup)
      // }
      
      if(authData?.token){
          // setLoding(true);
          const getData = async() =>{
              await getInbox(authData?.token, defPage, countShow, searchFact)
              .then(data => {
                // console.log('inboxS:', data)
                  setCountInbox(data?.length)
                  // setLoding(false)
              }).catch( e => {
                  // setError(true)
                  // setLoding(false)
              })
          }
          getData();
      }

    }, [authData, setCountInbox, authDataGroup, authDataLang])

    const handleProfileMenuOpen = (event) => {
        // setAnchorEl(event.currentTarget)
        // <ShopingList />
        navigate('/')
    };

    const handleMobileMenuClose = () => {
        setMobileMoreAnchorEl(null)
    };

    // const handleInboxMenuOpen = (event) => {
    //     setInboxMenu(event.currentTarget)
    //     handleMobileMenuClose()
    // };

    const handleInboxMenuClose = () => {
        setInboxMenu(null)
        handleMobileMenuClose()
    };

    const handleMobileMenuOpen = (event) => {
        setMobileMoreAnchorEl(event.currentTarget)
    };
    
    const addGroup=(e, mat) =>{
        
        setAnchorEl(false)
        if (e === 'Edit')
        {
            navigate("/mat-groups", { state: mat, replace: true })
        }else{
            navigate('/mat-groups')
        }
    }
    
    const submitGroup=( mat) =>{
        // e.preventDefault();
        // setMatGroup(mat)
        setAnchorEl(false)
        // onClick(mat)
        
        setAuthGroup(mat)

        // navigate(`/${mat.name}`);
        navigate(`/${mat.name}`, { state: {'searchData' : searchData}, replace: true })
    }


    const handleMyInbox=() =>{
        handleMobileMenuClose()
        navigate('/my-inbox')
    }

    // const menuInboxId = 'primary-search-account-menu';
    const renderInboxMenu = (
      <Menu
        anchorEl={inboxMenu}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        // id={menuInboxId}
        keepMounted
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        open={isMenuOpen}
        onClose={handleInboxMenuClose}
      >
        <MenuItem onClick={handleMyInbox} dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
            <Badge badgeContent={countInbox} color="error">
                <NotificationsIcon />
                {authDataLang?.site_langs?.desc_menu_msg}
            </Badge>
        </MenuItem>
      </Menu>
    );
    // const menuId = 'primary-search-account-menu';
    const renderMenu = (
      <React.Fragment>
          {/* <MenuGroupList materials={materials} anchor={'left'} isAdmin={isAdmin} anchorE={anchorEl}/> */}
      
        <SwipeableDrawer
            anchor={authDataLang?.view_sts ? "left" : "right"}
            sx={{width: '20%'}}
            color='primary'
            open={anchorEl}
            onClose={() => setAnchorEl(false)}
            onOpen={() => setAnchorEl(true)}
          >
            <Box
              sx={{ width: 'auto', height: '100%', background: 'secondary' }}
              role="presentation"
              // dir={authDataLang?.view_sts ? "rtl" : "ltr"}
              // onClick={toggleDrawer(anchor, false)}
              // onKeyDown={toggleDrawer(anchor, false)}
            >
              <List>
                {isAdmin &&
                <div >
                    <ListItem disablePadding  dir={authDataLang?.view_sts ? "rtl" : "ltr"}>
                        <ListItemButton onClick={() => addGroup('New', null)} >
                            <ListItemIcon >
                              <EditNoteIcon />
                            </ListItemIcon>
                            <ListItemText primary={
                              <>
                                  <Typography
                                      variant="h6"
                                      component={"div"}
                                      color="primary"
                                      fontFamily='b_mitra'
                                    >
                                      {authDataLang?.site_langs?.desc_new_group}
                                  </Typography>
                                  
                                </>
                              }/>
                          </ListItemButton>
                        
                      </ListItem>
                      <Divider />
                  </div>
                }
                {materials && materials?.map(matG => (
                    <ListItem key={matG.id} disablePadding dir={authDataLang?.view_sts ? "rtl" : "ltr"} >
                        <ListItemButton onClick={() => {submitGroup(matG)}} >
                            <ListItemIcon >
                                <ChevronLeftIcon />
                            </ListItemIcon>
                            <ListItemText primary={
                                  <>
                                    <Typography
                                        variant="h6"
                                        component={"div"}
                                        color="primary"
                                        fontFamily='b_mitra'
                                      >
                                        {matG.name}
                                    </Typography>
                                    
                                  </>
                                }
                            />
                        </ListItemButton>
                            {isAdmin &&
                                <ListItemIcon onClick={() => addGroup('Edit', matG)}>
                                    <AddIcon />
                                </ListItemIcon>
                            }
                    </ListItem>
                ))}
              </List>
              <Divider />
              
            </Box>
        </SwipeableDrawer>
        </React.Fragment>
    );
    const handleOpenLogin = () => {
        // setOpenDialog(true);
        // setOpenDialog(false);
        handleMobileMenuClose()
        // navigate("/login")
        setNewLoginPage(!newLoginPage)
        setFlagRun(4)
        setOpenLogin(true)
    };

    const handleProfileClick = (event) => {
        setAnchorProfile(event.currentTarget)
        // handleMobileMenuClose()
    };
    const handleProfileClose = () => {
        setAnchorProfile(null)
        handleMobileMenuClose()
    };

    // const myReport = () =>{
    //     handleMobileMenuClose()
    //     navigate('/report')
    // };

    const myRequestBuy = () =>{
        handleMobileMenuClose()
        navigate('/request-buy')
    };

    const myRequestFinal = () =>{
        handleMobileMenuClose()
        navigate('/request-final')
    };

    const myProfile = () =>{
        navigate('/account')
        handleMobileMenuClose()
    }
    
    const matBuyAdd = () =>{
        navigate('/mat-buy-add')
        handleMobileMenuClose()
    }
      
    const siteSettingHandler = () =>{
        navigate('/mysetting')
        handleMobileMenuClose()
    }

    const matAdd = () =>{
        navigate(`/mat-new`)
        handleMobileMenuClose()
        // navigate('/mat-new', {state : {"id":0}});
    }

    const logoutAccount = () =>{
        // setAuth(null);
        // // navigate('/');
        // handleMobileMenuClose();
        // window.location.href="/";
        navigate(`/logout`)
    };

    const menuProfile =(
        <Menu
          anchorEl={anchorProfile}
          id="account-menu"
          open={openProfileM}
          dir={authDataLang?.view_sts ? "ltr" : "rtl"}
          onClose={handleProfileClose}
          onClick={handleProfileClose}
          PaperProps={{
            elevation: 0,
            sx: {
              overflow: 'visible',
              filter: 'drop-shadow(0px 2px 8px rgba(0,0,0,0.32))',
              mt: 1.5,
              '& .MuiAvatar-root': {
                width: 32,
                height: 32,
                ml: -0.5,
                mr: 1,
              },
              '&:before': {
                content: '""',
                display: 'block',
                position: 'absolute',
                top: 0,
                right: 14,
                width: 10,
                height: 10,
                bgcolor: 'background.paper',
                transform: 'translateY(-50%) rotate(45deg)',
                zIndex: 0,
              },
            },
          }}
          transformOrigin={{ horizontal: 'left', vertical: 'top' }}
          anchorOrigin={{ horizontal: 'left', vertical: 'bottom' }}
        >
          {authData ?
            <div>
                <MenuItem onClick={myProfile}>
                    <BrightnessHighIcon sx={{marginRight: 2}} />
                    <Typography
                        component="span"
                        variant="h6"
                        color="text.primary"
                        fontFamily={'b_mitra'}
                        >
                        {authDataLang?.site_langs?.desc_menu_profile}
                    </Typography>
                </MenuItem>
                {isAdmin &&
                  <div>
                    <MenuItem onClick={matAdd}>
                        <CalendarViewMonthIcon sx={{marginRight: 2}} />
                        <Typography
                            component="span"
                            variant="h6"
                            color="text.primary"
                            fontFamily={'b_mitra'}
                            >
                            {authDataLang?.site_langs?.desc_menu_new_material}
                        </Typography>
                    </MenuItem>
                    <MenuItem onClick={matBuyAdd}>
                        <CameraFrontIcon sx={{marginRight: 2}} />
                        <Typography
                            component="span"
                            variant="h6"
                            color="text.primary"
                            fontFamily={'b_mitra'}
                            >
                            {authDataLang?.site_langs?.desc_menu_new_buy}
                        </Typography>
                    </MenuItem>
                    <MenuItem onClick={siteSettingHandler}>
                        <CameraFrontIcon sx={{marginRight: 2}} />
                        <Typography
                            component="span"
                            variant="h6"
                            color="text.primary"
                            fontFamily={'b_mitra'}
                            >
                            {authDataLang?.site_langs?.desc_menu_setting}
                        </Typography>
                    </MenuItem>
                  </div>
                }
                {/* <MenuItem onClick={myReport}>
                    <CardGiftcardIcon sx={{marginRight: 2}} />
                    <Typography
                        component="span"
                        variant="h6"
                        color="text.primary"
                        fontFamily={'b_mitra'}
                        >
                        {authDataLang?.site_langs?.desc_menu_report}
                    </Typography>
                </MenuItem> */}
                <Divider />
                {isAdmin &&
                  <MenuItem onClick={myRequestBuy}>
                      <CardGiftcardIcon sx={{marginRight: 2}} />
                      <Typography
                          component="span"
                          variant="h6"
                          color="text.primary"
                          fontFamily={'b_mitra'}
                          >
                            لیست درخواست مشاوره
                          {/* {authDataLang?.site_langs?.desc_menu_report} */}
                      </Typography>
                  </MenuItem>
                }
                <MenuItem onClick={myRequestFinal}>
                    <CardGiftcardIcon sx={{marginRight: 2}} />
                    <Typography
                        component="span"
                        variant="h6"
                        color="text.primary"
                        fontFamily={'b_mitra'}
                        >
                          گزارش عملکرد
                        {/* {authDataLang?.site_langs?.desc_menu_report} */}
                    </Typography>
                </MenuItem>
                <Divider />
                
                <MenuItem onClick={logoutAccount}>
                  <ListItemIcon>
                    <Logout fontSize="small" />
                  </ListItemIcon>
                  <Typography
                      component="span"
                      variant="h6"
                      color="text.primary"
                      fontFamily={'b_mitra'}
                      >
                      {authDataLang?.site_langs?.desc_menu_exit}
                  </Typography>
                </MenuItem>
            </div>
          :
            <div>
                <MenuItem onClick={handleOpenLogin}>
                    <Avatar />
                    <Typography
                        component="span"
                        variant="h6"
                        color="text.primary"
                        fontFamily={'b_mitra'}
                        >
                        {authDataLang?.site_langs?.desc_menu_login}/{authDataLang?.site_langs?.desc_register}
                    </Typography>
                </MenuItem>
            </div>
          }
      </Menu>
    );

    const mobileMenuId = 'primary-search-account-menu-mobile';
    const renderMobileMenu = (
        <Menu
            anchorEl={mobileMoreAnchorEl}
            anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            id={mobileMenuId}
            keepMounted
            transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
            }}
            open={isMobileMenuOpen}
            onClose={handleMobileMenuClose}
            dir={authDataLang?.view_sts ? "rtl" : "ltr"}
        >
        {authData?.token &&
            <div>
                <MenuItem >
                    {/* <ShopingList /> */}
                    <Typography
                        component="span"
                        variant="h6"
                        color="primary"
                        fontFamily={'b_mitra'}
                        >
                        سبدخرید
                    </Typography>
                </MenuItem>
                <MenuItem onClick={handleMyInbox} >
                    <Badge badgeContent={countInbox} color="error">
                        <NotificationsIcon />
                        <Typography
                            component="span"
                            variant="h6"
                            color="primary"
                            fontFamily={'b_mitra'}
                            >
                            {authDataLang?.site_langs?.desc_menu_msg}
                        </Typography>
                        
                    </Badge>
                </MenuItem>
            </div>
        }
        {authData ?
            <MenuItem onClick={handleProfileClick}>
                {authData?.user ?
                    <User user={authData?.user}/>
                :
                    <Avatar />
                }

                <Typography
                    component="span"
                    variant="h6"
                    color="primary"
                    fontFamily={'b_mitra'}
                    >
                    {authDataLang?.site_langs?.desc_account}
                </Typography>
            </MenuItem>        
        :
          <MenuItem onClick={handleOpenLogin}>
              <Avatar />
              <Typography
                  component="span"
                  variant="h6"
                  color="text.primary"
                  fontFamily={'b_mitra'}
                  >
                  {authDataLang?.site_langs?.desc_menu_login}/{authDataLang?.site_langs?.desc_register}
              </Typography>
          </MenuItem>
        }
        
        </Menu>
    );
    


    // const onSubmitSearchKeyPress = (event) => {
    //     if (event.code === "Enter" || event.code === "NumpadEnter") {
    //         event.preventDefault();
    //         if (!searchData) 
    //         {
    //             setSearchData(''); 
    //         }
    //         // console.log(searchData);
    //         navigate(`/${authDataGroup?.name}`, { state: {'searchData' : searchData}, replace: true });
    //         setSearchData('');
    //     }
    // };
    
  return (
    <Box sx={{ 
          flexGrow: 1 ,
      }}
      dir={authDataLang?.view_sts ? "rtl" : "ltr"}
      >
      <AppBar position="static" sx={{ backgroundColor: blueGrey[900]}}>
        <Toolbar 
            dir={authDataLang?.view_sts ? "rtl" : "ltr"}
            
            >
          <IconButton
              size="large"
              edge="start"
              color="inherit"
              aria-label="open drawer"
              sx={{ mr: 2 }}
              onClick={handleProfileMenuOpen}
            >
              <MenuIcon />
          </IconButton>
          
          <Typography
              variant="h6"
              component="div"
              noWrap
              sx={{ display: {  sm: 'block', fontFamily: 'b_mitra' }, mx: 2 }}
            >
              {authDataLang?.site_langs?.title}
          </Typography>
          
          <Box
              sx={{
                display: 'flex',
                alignItems: 'center',
                border: '1px solid gray',
                borderRadius: 5,
                padding: '2px 8px',
                width: expanded ? '300px' : '45px',
                transition: 'width 0.4s ease',
                bgcolor: 'background.paper',
                overflow: 'hidden',
              }}
            >
              <IconButton onClick={handleSearchClick} sx={{ p: 0.5 }}>
                <SearchIcon />
              </IconButton>

              {expanded && (
                <InputBase
                  inputRef={inputRef}
                  autoFocus
                  placeholder={authDataLang?.site_langs?.desc_search}
                  sx={{ ml: 1, flex: 1, fontFamily: 'b_mitra', fontSize: 20 }}
                  inputProps={{ 'aria-label': 'search' }}
                  value={searchData}
                  onChange={(e) => setSearchData(e.target.value)}
                  onBlur={handleBlur}
                  onKeyDown={handleKeyDown}
                />
              )}
            </Box>
          <Box sx={{ flexGrow: 1 }} />

          <Box sx={{ display: { xs: 'none', md: 'flex' } }}>
            {/* <IconButton size="large" aria-label="show 4 new mails" color="inherit">
                <ShopingList />
            </IconButton> */}
            {authData?.token &&
                <IconButton
                  size="large"
                  aria-label="show 17 new notifications"
                  color="inherit"
                  onClick={handleMyInbox}
                >
                    <Badge badgeContent={countInbox} color="error">
                      <NotificationsIcon />
                    </Badge>
                </IconButton>
            }
            <IconButton
              size="large"
              aria-label="show 17 new notifications"
              color="inherit"
              onClick={handleProfileClick}
            >
              
                {authData ?
                    <User user={authData?.user}/>
                :
                    <Avatar />
                }
            </IconButton>
                
          </Box>
          <Box sx={{ display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="show more"
              aria-controls={mobileMenuId}
              aria-haspopup="true"
              onClick={handleMobileMenuOpen}
              color="inherit"
            >
              <MoreIcon />
            </IconButton>
          </Box>
        </Toolbar>
      </AppBar>
      {renderMobileMenu}
      {renderMenu}
      {renderInboxMenu}
      {menuProfile}
      {openLogin &&
          <LoginDialog 
              open={openLogin} 
              newPage={newLoginPage} 
              onBack={handlerLoginBack}
              flagRun={flagRun}
              />
      }
    </Box>
  );
}

export default NavBarHeader;

// NavBarHeader.propTypes = {
//   onBack: PropTypes.func.isRequired,
//   // selectedValue: PropTypes.string.isRequired,
// };
